import $ from 'jquery'

$(document).on('turbo:load', () => {
  const contactType = $('#contact_person_contact_type')
  if (contactType.length === 0) return

  // E-Mail Addresses
  const addButton = $('#contact-person-emails a.add_fields')

  // Dont allow to add more than 3 email addresses for a ContactPerson
  const toggleAddLink = () => {
    if ($('.contact-person-email-fields:visible').length >= 3) {
      addButton.hide()
    } else {
      addButton.show()
    }
  }

  // Hide the delete button, if there is only one email address left
  const toggleDeleteButtons = () => {
    $('#contact-person-emails').toggleClass('only-email', $('.contact-person-email-fields:visible').length === 1)
  }

  // contact_type
  // Only the chosen type's fields belong to the form. The other type's
  // fieldset is hidden and disabled, so it is neither checked nor sent.
  const showContactType = () => {
    const internal = contactType.val() === 'internal'
    $('#contact-type-internal').prop({ hidden: !internal, disabled: !internal })
    $('#contact-type-external').prop({ hidden: internal, disabled: internal })

    // The email fields only count once they are shown
    toggleAddLink()
    toggleDeleteButtons()
  }

  showContactType()

  contactType.on('change', showContactType)

  // After adding a new email address field
  $('#contact-person-emails').on(
    'cocoon:after-insert',
    (_e, _insertedItem, _originalEvent) => {
      toggleAddLink()
      toggleDeleteButtons()
    }
  )

  // After removing an email address field
  $('#contact-person-emails').on(
    'cocoon:after-remove',
    (_e, _insertedItem, _originalEvent) => {
      toggleAddLink()
      toggleDeleteButtons()
    }
  )
})
